import { DEACTIVATE_CUSTOMER, GET_CUSTOMER, GET_CUSTOMER_ORDERS, ACTIVATE_CUSTOMER } from "./customer.constants";

export const getCustomer = (payload, callback) => ({type: GET_CUSTOMER, payload, callback})
export const getCustomerOrders = (payload, callback) => ({type: GET_CUSTOMER_ORDERS, payload, callback})
export const deactivateCustomer = (payload, callback) => ({type: DEACTIVATE_CUSTOMER, payload, callback})
export const activateCustomer = (payload, callback) => ({type: ACTIVATE_CUSTOMER, payload, callback})